
<div>
  <div v-for="(questionRep, index) in listeQuestionsReponses" :key="questionRep['id']">
    <div class="d-flex flex-column">
      <!-- TODO: Ajouter les icones aux questions -->
      <ZoneEscamotable :content="getContentZoneEscamotable(questionRep)" />
      <Separateur v-if="index !== listeQuestionsReponses.length - 1" class="w-100"></Separateur>
    </div>
  </div>
</div>
